<template>
    <div>
        <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
        <Filter />
        <div class="container trash-scan-layout">
    <div class="row">
        <div class="col-md-12">
            <div class="box">
              <sourceTable></sourceTable>
            </div>
        </div>
       
    </div>
    <div class="row mt-3">
        <div class="col-md-12">
            <div class="box">
              <destinationTable></destinationTable>
            </div>
        </div>
    </div>
</div>
    </div>

</template>
<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import sourceTable from "@/pages/archival/trash-scan/source-table.vue";
import destinationTable from "@/pages/archival/trash-scan/destination-table.vue"
export default {
    name: "trash-scan",
    components: {
        Header,
        Filter,
        sourceTable,
        destinationTable
    },
    data() {
      return {
        breadcrumsfirst: "Archival",
        breadcrumslast: "Trash Scan",
        filterConfig: {
          buttonConfig: {
            show: false,
            link: ''
          }
        },
      
      };
    },
 
}
</script>
<style>
 .box {
            background-color: #ffffff;
            border: 1px solid #e7e7e7;
            text-align: center;
            height: 276.3px; /* Adjust height as needed */
            border-radius: 8px;
            margin-left: -0.75rem;
            margin-right: -0.75rem;
            overflow-y: auto; 
            scrollbar-width: thin; /* For Firefox */
            /* scrollbar-color: #888 #f8f9fa;  */
            
        }
        .trash-scan-layout{
            background-color: #e7e7e7;
            border-radius: 8px;
        }
       

</style>
